import React, {Component} from "react";
import {connect} from "react-redux";
import {fromJS} from "immutable";
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import PanelGroupController from "../../components/PanelGroupController";
import FilterPanel from "../../components/panels/FilterPanel";
import ActionButton from "../../components/ActionButton";
import PartnersList from "./views/PartnersList";
import PartnerPropertiesPanel from "./panels/PartnerPropertiesPanel";
import {requestCreatePartner, requestEditPartner, requestEditPartnerAddress} from "../../actions/PartnerApiActions";
import {withRole} from "./roleLabels";

const roleFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "client", label: "Clients"},
  {id: "supplier", label: "Suppliers"},
]);

// Clients we dispatch stock to and suppliers we buy from ("partners" in the code).
class PartnersPage extends Component {

  constructor(props) {
    super(props);
    this.state = {partnerId: "", roleFilter: ""};
  }

  render() {
    return (
      <div className="PartnersPage SecurePage">
        <AppSidebar />
        <PageHeader title="Clients & Suppliers" backButton={false} />
        <div className="PageContainer">
          <PartnersList
            selectedId={this.state.partnerId}
            roleFilter={this.state.roleFilter}
            onSelectionChange={(partnerId) => this.setState({partnerId})}
            />
        </div>
        <div className="PanelContainer">
          <div className="header" />
          <PartnerPropertiesPanel expanded={true} partnerId={this.state.partnerId} />
          <FilterPanel
            title="Role"
            expanded={true}
            options={roleFilterOptions}
            onClick={(item) => this.setState({roleFilter: item.get("id")})}
            filter={this.state.roleFilter}
            />
          <PanelGroupController title="Actions">
            <ActionButton label={withRole("Add", this.state.roleFilter)}
              onClick={() => this.props.requestCreatePartner(this.state.roleFilter)} />
            <ActionButton label={withRole("Edit", this.state.roleFilter)} active={!!this.state.partnerId}
              onClick={() => this.props.requestEditPartner(this.state.partnerId, this.state.roleFilter)} />
            <ActionButton label="Add Address" active={!!this.state.partnerId}
              onClick={() => this.props.requestEditPartnerAddress(this.state.partnerId)} />
          </PanelGroupController>
        </div>
      </div>
    );
  }
}

export default connect(null, {requestCreatePartner, requestEditPartner, requestEditPartnerAddress})(PartnersPage);
